"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsEnum = void 0;
const TabsEnum = exports.TabsEnum = {
  removeToken: "CREDENTIALS_FLUSH",
  startingTab: "REQUESTING_SHARED_CREDENTIALS",
  sharingCredentials: "CREDENTIALS_SHARING"
};